/**
 * Dynamically updates page title and meta tags for SEO
 * @param {Object} data - SEO data object
 * @param {string} data.title - Page title
 * @param {string} data.metaDescription - Meta description
 */
import { logError } from 'utils/logger';

export const generatePageTitle = (data = {}) => {
  try {
    // CRITICAL: No defaults - this codebase serves 100+ sites
    // Only set title/description if provided, otherwise leave empty
    data.title = data.title || '';
    data.metaDescription = data.metaDescription || '';

    // Update document title
    document.title = data.title.toString();

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', data.metaDescription.toString());
    }

    // Update or create Open Graph meta tags
    updateOrCreateMetaTag('property', 'og:title', data.title.toString());
    updateOrCreateMetaTag(
      'property',
      'og:description',
      data.metaDescription.toString()
    );
    updateOrCreateMetaTag('property', 'og:type', 'website');
    updateOrCreateMetaTag('property', 'og:url', window.location.href);

    // Update or create Twitter Card meta tags
    updateOrCreateMetaTag('name', 'twitter:card', 'summary_large_image');
    updateOrCreateMetaTag('name', 'twitter:title', data.title.toString());
    updateOrCreateMetaTag(
      'name',
      'twitter:description',
      data.metaDescription.toString()
    );
  } catch (error) {
    logError('Failed to generate page title', error, data);
  }
};

/**
 * Helper function to update or create meta tags
 * @param {string} attribute - 'name' or 'property'
 * @param {string} attributeValue - The value of the attribute
 * @param {string} content - The content value
 */
function updateOrCreateMetaTag(attribute, attributeValue, content) {
  let metaTag = document.querySelector(
    `meta[${attribute}="${attributeValue}"]`
  );

  if (!metaTag) {
    metaTag = document.createElement('meta');
    metaTag.setAttribute(attribute, attributeValue);
    document.head.appendChild(metaTag);
  }

  metaTag.setAttribute('content', content);
}
